import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
	apiKey: "AIzaSyAjkO6YnChD7YMdsLirMFXIhZbeyPBxHpw",
	authDomain: "brushfire-online.firebaseapp.com",
	databaseURL: "https://brushfire-online.firebaseio.com",
	projectId: "brushfire-online",
	storageBucket: "brushfire-online.appspot.com",
	messagingSenderId: "197876363395",
	appId: "1:197876363395:web:975b592b93461b26526bb6",
	measurementId: "G-VNPTCT0KQX",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const rtdb = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Enable long polling for Firestore (Note: settings have changed in v10)
// Use enableIndexedDbPersistence or enableMultiTabIndexedDbPersistence instead as needed

export { app, db, auth, storage, rtdb };
export default app;
